import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
class SwissRegisterAllowedGuardService {
  protected router: Router = inject(Router);

  canActivate(): boolean {
    const isGermanLocation = window.location.hostname.includes('inyova.de');

    if (isGermanLocation) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}

export const SwissRegisterAllowedGuard: CanActivateFn = () => {
  return inject(SwissRegisterAllowedGuardService).canActivate();
};
